// extracted by mini-css-extract-plugin
export default {"QuestionsListDiv":"QuestionsList_QuestionsListDiv__UTgsH","QuestionsListSection":"QuestionsList_QuestionsListSection__+BQli","ClearAll":"QuestionsList_ClearAll__itip7"};